import { PartnerType } from 'legacy/lut/classes/models/PartnerType'
import { FC, useCallback } from 'react'

import { QBR_PARTNER_TYPE_OPTIONS } from 'partner360/components/QBR/configs'
import { RowButtons } from 'partner360/components/rowButtons/RowButtons'

import { IQbrPartnerTypeButtonsProps } from '../../../../models/qbrPartnerTypeButtonsProps'

export const QbrPartnerTypeButtons: FC<IQbrPartnerTypeButtonsProps> = ({
  value,
  translationKeyPrefix,
  onOptionClick,
  buttonClassName,
  containerClassName,
}) => {
  const generateTranslationKey = useCallback(
    (option: PartnerType) => {
      return `${translationKeyPrefix}--${option.toLowerCase()}-button`
    },
    [translationKeyPrefix]
  )

  return (
    <RowButtons
      value={value}
      options={QBR_PARTNER_TYPE_OPTIONS}
      generateTranslationKey={generateTranslationKey}
      onOptionClick={onOptionClick}
      buttonClassName={buttonClassName}
      containerClassName={containerClassName}
    />
  )
}
